import { getCustomerById } from './customerService';
import { useQuery } from '@tanstack/react-query';
import { customAxiosInstanceMutator } from './custom-axios-instance';
import type { IndividualIdentityCheck, IndividualIdentityStatus } from './schemas/customerServiceSchemas';
import type { Customer } from './schemas/customerServiceSchemas';
import type { Individual } from './schemas/customerServiceSchemas/individual';

const url = (id: string) => `/customer/api/v1/customers/${encodeURIComponent(id)}/individual-identity`;
export const identityQueryKey = (id?: string) => ['individualIdentity', id];
export const checkIndividualIdentity = (id: string, data: IndividualIdentityCheck) =>
  customAxiosInstanceMutator<IndividualIdentityStatus>({ url: `/loan/api/v1/customers/${encodeURIComponent(id)}/individual-identity`, method: 'POST', data });
export const useIndividualIdentity = (id?: string) => useQuery({
  queryKey: identityQueryKey(id),
  queryFn: () => customAxiosInstanceMutator<IndividualIdentityStatus>({ url: url(id!), method: 'GET' }),
  enabled: !!id
});

/** Include the captured version of the identity so a late report cannot correct newer input. */
export function identityCheckInput(customer: Customer, reportId?: string, applyCorrections = false): IndividualIdentityCheck {
  if (customer.type !== 'INDIVIDUAL' || customer.info?.type !== 'INDIVIDUAL') throw new Error('Individual customer not found');
  const person = customer.info as Individual;
  return { reportId, applyCorrections, expectedId: person.idNumber,
    ...(person.idType === 'PASSPORT' && { expectedIdType: person.idType }),
    expectedGivenNames: person.firstName, expectedSurname: person.lastName };
}

/** Read the current saved profile; the API still rejects concurrent changes. */
export async function checkSavedIndividualIdentity(customerId: string, reportId?: string) {
  const customer = await getCustomerById(customerId);
  return checkIndividualIdentity(customerId, identityCheckInput(customer, reportId));
}
